import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
}) export class DataCommunicationService {
    private buttonSubmitSubject = new Subject<any>();
    private addButtonSubmitSubject = new Subject<any>();
    private addButtonVisibleEventSubject = new Subject<any>();
    private isFormEnableSubject = new Subject<any>();
    private isLoaderEventSubject = new Subject<any>();

    public buttonSubmitEvent = this.buttonSubmitSubject.asObservable();
    public addButtonSubmitEvent = this.addButtonSubmitSubject.asObservable();
    public addButtonVisibleEvent = this.addButtonVisibleEventSubject.asObservable();
    public isFormEnableEvent = this.isFormEnableSubject.asObservable();
    public isLoaderEvent = this.isLoaderEventSubject.asObservable();


    buttonSubmit(data: any) {
        console.log(data);
        this.buttonSubmitSubject.next(data);
    }

    addButtonSubmit(data: any) {
        this.addButtonSubmitSubject.next(data);
    }

    addBttnVisible(data: any) {
        this.addButtonVisibleEventSubject.next(data);
    }

    formEnable(data: any) {
        this.isFormEnableSubject.next(data);
    }

    isLoader(data: any) {
        this.isLoaderEventSubject.next(data);
    }
}